<template>
  <div class="login  d-flex flex-column bg-linear-4C2C7C-00A8DF h-100">
    <v-container fluid class="ma-0 pa-0 pt-2 bg-blue-lighten-1">
      <v-container fluid scroll-behavior="elevate" class="d-flex justify-space-between ma-0 px-sm-25 pt-2 pb-4 pb bg-indigo-darken-3">
          <img src="@/assets/images/wug-torino-2025.svg" class="w-100px w-sm-150px">

          <img src="@/assets/images/3bmeteo.svg" class="w-100px w-sm-150px">
      </v-container>
    </v-container>



    <v-container class="flex-1-0-0 d-flex">
      <v-container class="my-auto px-0 px-sm-4">
        <v-container class="mb-8 px-0 px-sm-4">
          <v-container class="pa-0 text-white text-center text-subtitle-1">{{ $t('login.heading.subtitle') }}</v-container>
          <v-container class="pa-0 text-white text-center text-h3 font-weight-medium">{{ $t('login.heading.title') }}</v-container>
        </v-container>

        <v-card class="w-sm-50 bg-white mx-auto py-8 px-1 px-sm-6 d-flex flex-column rounded-lg">
          <v-container class="text-center text-h5 font-weight-medium">{{ $t('login.form.title') }}</v-container>
          <v-form ref="form" class="" validate-on="submit">
            <v-container class="d-flex flex-column">
              <v-text-field
                v-model="email.value"
                :label="$t('login.form.email.label')"
                :hint="$t('login.form.email.hint')" persistent-hint
                variant="outlined" class="mb-5 text-grey-darken-1" color="indigo"
                :rules="email.rules"
              ></v-text-field>

              <v-text-field
                v-model="password.value"
                :label="$t('login.form.password.label')"
                :hint="$t('login.form.password.hint')" persistent-hint
                variant="outlined" class="mb-5 text-grey-darken-1" color="indigo"
                :rules="password.rules"
                :type="password.show ? 'text' : 'password'"
                :append-icon="password.show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="password.show = !password.show"
              ></v-text-field>

            <v-checkbox
                v-model="rememberMe"
                hide-details
                label="Ricordami"
                color="blue-grey-darken-1"
              ></v-checkbox>
            </v-container>
          </v-form>

          <v-btn
            variant="flat" class="mx-auto bg-blue-darken-3 text-white text-body-1 rounded-lg"
            @click="login"
          >
            {{ $t('login.form.submit') }}
          </v-btn>
        </v-card>
      </v-container>
    </v-container>

    <v-container fluid height="100" class="bg-indigo-darken-3"></v-container>

    <v-snackbar
      v-model="snackbar.opened"
      :timeout="3000"
    >
      {{ $t(`snackbar.${ snackbar.message }`) }}
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import { LoginRequest } from '@/modules/api';
import { ErrorState } from '@/modules/store';
import { StorageService } from '@/services/storageService';
import { store } from '@/store';
import { defineComponent, Ref } from 'vue';
import * as constants from '@/utils/constants';


export default defineComponent({
  name: 'login',
  components: {
  },
  data(): LoginDataInterface {
    return {
      email: {
        value: undefined,
        rules: [
          (value: string) => {
            if (value) return true;
            return this.$t('login.form.email.not-found');
          },
          (value: string) => {
            if (constants.emailRegex.test(value)) return true;
            return this.$t('login.form.email.not-valid');
          },
        ]
      },
      password: {
        value: undefined,
        rules: [
          (value: string) => {
            if (value) return true;
            return this.$t('login.form.password.not-found');
          },
        ],
        show: false
      },
      rememberMe: false,
      snackbar: {
        opened: false,
        message: undefined,
      }
    }
  },
  mounted() {
    this.rememberMe = StorageService.instance.getUseLocalStorage();
  },
  methods: {
    async login() {
      const formRef: VForm = this.$refs.form as VForm;
      if (!formRef) {
        this.snackbar.message = "error-during-validate";
        this.snackbar.opened = true;
        return;
      }
      const valid = formRef.validate();

      if (!valid) {
        return;
      }
      
      const loginRequest: LoginRequest = {
        email: this.email.value!,
        password: this.password.value!,
        rememberMe: this.rememberMe
      };

      store.dispatch("login", loginRequest)
        .then(() => {
          this.$router.push('/')
        })
        .catch(() => {
          const errorState: ErrorState = store.getters.error;
          console.log(`${ errorState.isError } - ${ errorState.message }`);

          if (errorState.isError) {
            this.snackbar.message = errorState.message;
            this.snackbar.opened = true;
          }
        })
    }
  }

});


interface LoginDataInterface {
  email: {
    value: string | undefined;
    rules: any[];
  };
  password: {
    value: string | undefined;
    rules: any[];
    show: boolean;
  };
  rememberMe: boolean;
  snackbar: {
    opened: boolean;
    message: string | undefined;
  }
}
type VForm = Ref & { validate: () => boolean }

</script>
